import { render, staticRenderFns } from "./RegistraPezziMulti.vue?vue&type=template&id=ef8ac34e&scoped=true&"
import script from "./RegistraPezziMulti.vue?vue&type=script&lang=js&"
export * from "./RegistraPezziMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef8ac34e",
  null
  
)

export default component.exports